import { environmentHttpClient } from "../httpClient";
import {
	EmailAttachmentResultModel,
	InsertAttachmentsToExchangeEmailRequestModel,
	MailMessageLocationModel
} from "./common";

export type WebDavEmailAttachment = {
	fileId: string;
	serverId: number;
};

export async function uploadWebDavAttachments(
	data: InsertAttachmentsToExchangeEmailRequestModel<WebDavEmailAttachment>,
	signal?: AbortSignal
): Promise<readonly EmailAttachmentResultModel[]> {
	return environmentHttpClient.post<readonly EmailAttachmentResultModel[]>(
		"Email/Attachments/WebDav/Attach",
		data,
		{ signal }
	);
}

export type SaveAttachmentAsOnWebDavModel = {
	name: string;
	folderId: string;
	serverId: number;
	message: MailMessageLocationModel;
	exchangeAttachmentId: string;
};

export type SaveAttachmentToWebDavResponseModel = {
	serverId: number;
	parentFolderId: string;
	id: string;
	name: string;
};

export function saveAttachmentAsOnWebDav(
	saveData: SaveAttachmentAsOnWebDavModel,
	signal?: AbortSignal
): Promise<SaveAttachmentToWebDavResponseModel> {
	return environmentHttpClient.post<SaveAttachmentToWebDavResponseModel>(
		"Email/Attachments/WebDav/SaveAs",
		saveData,
		{ signal }
	);
}
